import { ExtensionRequestActionType } from '../actionTypes/extensionRequest';
import { PostDispatch } from '../types';

const reducer = (state = null, action: PostDispatch) => {
    switch (action.type) {
        case ExtensionRequestActionType.SAVE_EXTENSION_REQUEST:
        case ExtensionRequestActionType.GET_EXTENSION_REQUEST_BY_ID:
        case ExtensionRequestActionType.UPLOAD_EXTENSION_REQUEST_FILE:
        case ExtensionRequestActionType.RESPOND_TO_EXTENSION_REQUEST:
        case ExtensionRequestActionType.CONFIRM_ANSWERED_EXTENSION_REQUEST:
            return action.payload;
        default:
            return state;
    }
};

export default reducer;
